import React, { Component } from 'react';
import { Area } from './Area.js';
import { Branch } from './Branch.js';
import { TotalRow } from './TotalRow.js';

export class Union extends Component {

    constructor(props) {
        super(props);
        this.state = {
            totalMembers: 0,
            unemployed: 0,
            affected: 0
        }
    }

    handleCallback = (childData) => {
        if (childData.indexOf('noofmembers') > -1) {
            let newMembers = parseInt(this.state.totalMembers) + parseInt(childData.replace('noofmembers:', ''));
            this.setState({ totalMembers: newMembers });
        }

        if (childData.indexOf('noofaffected') > -1) {
            let newAffected = parseInt(this.state.affected) + parseInt(childData.replace('noofaffected:', ''));
            this.setState({ affected: newAffected });
        }

        if (childData.indexOf('unemployed') > -1) {
            let newUnemployed = parseInt(this.state.unemployed) + parseInt(childData.replace('noofunemployed:', ''));
            this.setState({ unemployed: newUnemployed });
        }
    }

    componentDidUpdate(prevState) {
        if (this.state.unemployed !== prevState.unemployed) {
            //console.log(this.state.unemployed);
        }
    }

    getBranches(branches) {
        if (branches === undefined) {
            return null;
        }

        let branchesArr = [];
        branchesArr.push(<div key={0} className='table-header row'><div className='col1'>Afdeling</div><div className='col2'></div><div className='col3'>Antal medlemmer</div><div className='col4'>Fuldtidsledige</div><div className='col5'>Fuldtids ledighed</div><div className='col6'>Berørte</div><div className='col7'>Berørtes ledighed</div></div>);
        //branchesArr.push(<thead key={0}><tr key={0}><th>Afdeling</th><th></th><th>Ledige</th><th>Antal medlemmer</th><th>%</th></tr></thead>);

        //branchesArr.push(<tbody key={1}>{this.getBranchesToTbody(branches)}</tbody>);
        branchesArr.push(<div key={1}>{this.getBranchesToTbody(branches, 'branch')}</div>);

        return branchesArr;
    }

    getBranchesToTbody(branches, type) {
        let tbodyArr = [];

        for (let i = 0; i < branches.length; i++) {
            let rowEven = i % 2;
            //tbodyArr.push(<div key={i + 2} className='row'><div className='col1'>{branches[i].branchname}</div><div className='col2'>{branches[i].description}</div><div className='col3'></div><div className='col4'></div><div className='col5'></div></div>);
            tbodyArr.push(<Branch key={i + 2} type={type} branchname={branches[i].branchname} description={branches[i].description} period={this.props.period} rowclass={rowEven} parentCallback={this.handleCallback} />);
            //tbodyArr.push(<tr key={i + 2}><td>{branches[i].branchname}</td><td>{branches[i].description}</td><td></td><td></td><td></td></tr>);
        }

        return tbodyArr;
    }

    getAreasToTbody() {
        let tbodyArr = [];

        for (let i = 0; i < this.props.unionareas.length; i++) {
            //tbodyArr.push(<tr key={i + 2}><td>{this.props.unionareas[i].areaname}</td><td>{this.props.unionareas[i].description}</td><td></td><td></td><td></td></tr>);
            tbodyArr.push(<div key={i + 2}><Area areaname={this.props.unionareas[i].areaname} description={this.props.unionareas[i].description} branches={this.props.unionareas[i].branches} period={this.props.period} parentCallback={this.handleCallback} /></div>);
        }

        return tbodyArr;
    }

    getAreas() {
        if (this.props.unionareas === undefined) {
            return null;
        }

        let areasArr = [];
        //areasArr.push(<thead key={0}><tr key={0}><th>Kreds</th><th></th><th>Ledige</th><th>Antal medlemmer</th><th>%</th></tr></thead>);
        areasArr.push(<div key={0}><div key={0} className='table-header row'><div className='col1'>Kreds</div><div className='col2'></div><div className='col3'>Antal medlemmer</div><div className='col4'>Fuldtids<br className='wordsplit' />ledige</div><div className='col5'>Fuldtids ledighed</div><div className='col6'>Berørte</div><div className='col7'>Berørte ledighed</div></div></div>);

        areasArr.push(<div key={1} className='area-container'>{this.getAreasToTbody()}</div>);
        //areasArr.push(<tbody key={1}>{this.getAreasToTbody()}</tbody>);

        return areasArr;
    }

    render() {
        return (
            <div className='org-container'>
                <h4>Ledige hos {this.props.name}</h4>
                <div className='div-table'>
                    {this.getBranches(this.props.branches)}
                    {this.getAreas()}
                    <TotalRow totalMembers={this.state.totalMembers} unemployed={this.state.unemployed} affected={this.state.affected} />
                </div>
            </div>
        );
    }
}